const LEGACY_CAMPAIGN_PATH =
	/^\/campaigns\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})(?:\/.*)?$/;

export function resolveNotificationCtaPath(ctaPath?: string | null): string | null {
	if (!ctaPath?.startsWith("/")) return null;
	const legacy = ctaPath.match(LEGACY_CAMPAIGN_PATH);
	if (legacy) {
		return `/campaign-detail?campaignId=${legacy[1]}&returnTo=${encodeURIComponent("/campaigns")}`;
	}
	return ctaPath;
}
